// Approximate coordinates for Swiss cities/cantons – used to plot listings on the map
// without an external geocoding service. Falls back to Bern centre.
export const CH_CENTER = [46.8182, 8.2275];

export const SWISS_GEO = {
  "zürich": [47.3769, 8.5417],
  "zurich": [47.3769, 8.5417],
  "bern": [46.948, 7.4474],
  "basel": [47.5596, 7.5886],
  "genf": [46.2044, 6.1432],
  "geneva": [46.2044, 6.1432],
  "lausanne": [46.5197, 6.6323],
  "luzern": [47.0502, 8.3093],
  "lucerne": [47.0502, 8.3093],
  "winterthur": [47.5022, 8.7386],
  "st. gallen": [47.4245, 9.3767],
  "st gallen": [47.4245, 9.3767],
  "lugano": [46.0037, 8.9511],
  "biel": [47.1368, 7.2467],
  "bienne": [47.1368, 7.2467],
  "thun": [46.7580, 7.6280],
  "köniz": [46.9244, 7.4145],
  "la chaux-de-fonds": [47.0996, 6.8265],
  "schaffhausen": [47.6976, 8.6345],
  "fribourg": [46.8061, 7.1620],
  "freiburg": [46.8061, 7.1620],
  "chur": [46.8499, 9.5320],
  "neuenburg": [46.9925, 6.9314],
  "neuchâtel": [46.9925, 6.9314],
  "uster": [47.3471, 8.7211],
  "sion": [46.2331, 7.3606],
  "sitten": [46.2331, 7.3606],
  "zug": [47.1662, 8.5155],
  "aarau": [47.3927, 8.0444],
  "baden": [47.4731, 8.3070],
  "bellinzona": [46.1947, 9.0258],
  "frauenfeld": [47.5575, 8.8987],
  "solothurn": [47.2078, 7.5374],
  "wil": [47.4628, 9.0457],
  "rapperswil": [47.2247, 8.8186],
  "wetzikon": [47.3239, 8.8004],
  "kloten": [47.4517, 8.5852],
  "dübendorf": [47.3979, 8.6182],
  "horgen": [47.2599, 8.5961],
  "olten": [47.3500, 7.9050],
};

export function geocodeLocation(loc) {
  if (!loc) return null;
  const key = loc.trim().toLowerCase().split(/[,\s/]+/)[0];
  if (!key) return null;
  return SWISS_GEO[key] || SWISS_GEO[loc.trim().toLowerCase()] || null;
}
